import Chart from 'react-apexcharts';

const BarChart = ({ labels, series }) => {
    const options = {
        chart: {
            type: 'bar',
            height: 350,
            locales: [
                {
                    name: "tr",
                    options: {
                        months: [
                            "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
                            "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
                        ],
                        shortMonths: [
                            "Oca", "Şub", "Mar", "Nis", "May", "Haz",
                            "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"
                        ],
                        days: [
                            "Pazar", "Pazartesi", "Salı", "Çarşamba", 
                            "Perşembe", "Cuma", "Cumartesi"
                        ],
                        shortDays: ["Pzr", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
                        toolbar: {
                            exportToSVG: "SVG İndir",
                            exportToPNG: "PNG İndir",
                            exportToCSV: "CSV İndir",
                            menu: "Menü",
                            selection: "Seçim",
                            selectionZoom: "Bölge Yakınlaştır",
                            zoomIn: "Yakınlaştır",
                            zoomOut: "Uzaklaştır",
                            pan: "Kaydır",
                            reset: "Sıfırla"
                        }
                    }
                }
            ],
            defaultLocale: "tr"
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: labels,
        },
        colors: undefined, // ApexCharts'ın otomatik renklerini kullan
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 300
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }
        ]
    };

    return (
        <Chart options={options} series={series} type="bar" height={350} />
    );
};

export default BarChart;
